window.PXUTheme = window.PXUTheme || {};

(function(ns) {
  // Prevent redeclaration if loaded twice
  if (ns.SmartGallery) return;

  // SmartGallery class scoped under PXUTheme
  ns.SmartGallery = class {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.imageParent = wrapper.querySelector(".smart-gallery");
      this.inactiveGallery = wrapper.querySelector(".smart-gallery-inactive");
      this.flickityInstance = null;
      this.selectedVariant = this.imageParent?.dataset.selectedVariant || "";
      this._onResize = this.initializeFlickityIfNeeded.bind(this);
    }

    init() {
      if (!this.imageParent || !this.inactiveGallery) {
        console.error("Smart Gallery containers not found in", this.wrapper);
        return;
      }
      if (this.wrapper.querySelector(".smart-gallery__limiter")) {
        this.watchLimiters();
      }
      this.watchSwappers();
      this.updateActiveImages();
      this.watchGallerySwatches();
      this.watchVideoActions();
      this.lockGalleryHeight();
      window.addEventListener("resize", this._onResize);
    }

    lockGalleryHeight() {
      const h = this.imageParent.offsetHeight;
      this.imageParent.style.minHeight = `${h}px`;
    }

    watchLimiters() {
      this.wrapper.querySelectorAll(".smart-gallery__limiter").forEach(limiter => {
        limiter.addEventListener("click", () => {
          this.imageParent.classList.add("unlimited");
          limiter.classList.add("hidden");
        });
      });
    }

    watchSwappers() {
      document.querySelectorAll("[data-swapper]").forEach(swapper => {
        const handler = (event) => {
          const newVariant = event.target.dataset.swapper;
          // Update bundle option title if present
          const bundleOption = swapper.closest(".product-bundle__option");
          if (bundleOption) {
            const titleEl = bundleOption.querySelector("[data-selected-colour]");
            if (titleEl) titleEl.textContent = event.target.dataset.title;
          }
          // Update select-colour display
          const selectColour = document.querySelector('[data-select-colour] b');
          if (selectColour) {
            selectColour.textContent = event.target.dataset.colour;
          }

          this.selectedVariant = newVariant;
          this.imageParent.dataset.selectedVariant = newVariant;

          if(newVariant === "false" || newVariant === "default-title") {
            return;
          }
          this.updateActiveImages(newVariant);
        };
        swapper.addEventListener("change", handler);
        swapper.addEventListener("click", handler);
      });
    }

    watchGallerySwatches() {
      this.wrapper.querySelectorAll(".gallery-swatches .gallery-swatch").forEach(swatch => {
        swatch.addEventListener("click", () => {
          const active = this.wrapper.querySelector(".gallery-swatch.active");
          if (active) active.classList.remove("active");
          swatch.classList.add("active");

          // Sync variant input
          const input = document.getElementById(`input-swatch--${swatch.dataset.swapper}`);
          if (input) {
            input.checked = true;
            input.closest("fieldset").dataset.stickySelection = "selected";
            if (window.PXUTheme.jsGlobalProduct?.updateFloatingATC) {
              window.PXUTheme.jsGlobalProduct.updateFloatingATC();
            }
          }

          const selectionEl = document.querySelector(".swatch__options-selection");
          if (selectionEl) selectionEl.textContent = swatch.dataset.colour;
        });
      });
    }

    initializeFlickityIfNeeded() {
      if (window.innerWidth < 768 || this.imageParent.classList.contains("carousel") || this.imageParent.classList.contains("modal")) {
        if (!this.flickityInstance) {
          const showDots = this.imageParent.classList.contains("dots");
          this.flickityInstance = new Flickity(this.imageParent, {
            cellAlign: "left",
            contain: true,
            pageDots: showDots,
            prevNextButtons: true,
            wrapAround: true,
            imagesLoaded: true,
          });
        }
      } else if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
    }

    updateActiveImages(newVariant = this.selectedVariant) {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }

      this.imageParent.innerHTML = "";

      const matchingCells = [];
      const inactiveCells = this.inactiveGallery.querySelectorAll("div.gallery-cell");
      inactiveCells.forEach(cell => {
        const anchor = cell.querySelector("a");
        const smartImg = anchor?.querySelector("smartimg");
        if (smartImg && (newVariant === "false" || newVariant === "default-title" || smartImg.getAttribute("alt") === `xs:${newVariant}`)) {
          const clonedCell = cell.cloneNode(true);
          const clonedAnchor = clonedCell.querySelector("a");
          const clonedSmartImg = clonedAnchor?.querySelector("smartimg");
          if (clonedSmartImg) {
            const video = clonedSmartImg.querySelector("video");
            if (video) {
              const pauseIcon = clonedSmartImg.querySelector(".gicon--pause");
              const videoContainer = document.createElement("div");
              videoContainer.classList.add("video-wrapper");
              videoContainer.appendChild(video);
              if (pauseIcon) videoContainer.appendChild(pauseIcon.cloneNode(true));
              clonedSmartImg.replaceWith(videoContainer);
            } else {
              const img = document.createElement("img");
              this.copyAttributes(clonedSmartImg, img);
              clonedSmartImg.replaceWith(img);
            }
          }
          clonedAnchor.classList.remove("hidden");
          matchingCells.push(clonedCell);
        }
      });

      const fragment = document.createDocumentFragment();
      matchingCells.forEach(cell => fragment.appendChild(cell));
      this.imageParent.appendChild(fragment);

      this.initializeFlickityIfNeeded();
      this.watchVideoActions();
    }

    watchVideoActions() {
      this.wrapper.querySelectorAll(".gallery-cell video").forEach(video => {
        const parent = video.closest(".gallery-cell");
        const icon = parent.querySelector(".gicon");
        icon.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play();
            icon.classList.add("gicon--pause");
            icon.classList.remove("gicon--play");
          } else {
            video.pause();
            icon.classList.remove("gicon--pause");
            icon.classList.add("gicon--play");
          }
        });
      });
    }

    copyAttributes(fromEl, toEl) {
      Array.from(fromEl.attributes).forEach(attr => {
        toEl.setAttribute(attr.name, attr.value);
      });
      Object.keys(fromEl.dataset).forEach(key => {
        toEl.dataset[key] = fromEl.dataset[key];
      });
    }

    destroy() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
      window.removeEventListener("resize", this._onResize);
    }
  };

  // Static initializer for all containers
  ns.jsSmartGallery = {
    controllers: [],
    initAll() {
      this.controllers = [];
      document.querySelectorAll(".smart-gallery-container").forEach(wrapper => {
        const instance = new ns.SmartGallery(wrapper);
        instance.init();
        this.controllers.push(instance);
      });
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    ns.jsSmartGallery.initAll();
  });

})(window.PXUTheme);